export const META_IMAGE_WIDTH = 1200
export const META_IMAGE_HEIGHT = 630
